import { useTheme } from '@mui/material';

export const IntroIcon3 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M2.9 11.429c.495 0 .9.386.9.857V26c0 2.368 2.014 4.286 4.5 4.286h23.4c.495 0 .9.385.9.857 0 .47-.405.857-.9.857H8.3C4.818 32 2 29.316 2 26V12.286c0-.471.405-.857.9-.857ZM34.4 8c1.986 0 3.6 1.538 3.6 3.429v1.594l-1.8-.011v-1.583c0-.948-.804-1.715-1.8-1.715H11c-.996 0-1.8.766-1.8 1.715v12c0 .948.804 1.714 1.8 1.714h23.4c.996 0 1.8-.766 1.8-1.714V18.2l1.8.01v5.219c0 1.89-1.614 3.428-3.6 3.428H11c-1.986 0-3.6-1.537-3.6-3.428v-12C7.4 9.538 9.014 8 11 8h23.4Zm-11.7 4.286a5.54 5.54 0 0 1 3.819 1.506 5.022 5.022 0 0 1 1.58 3.637 5.022 5.022 0 0 1-1.58 3.636 5.54 5.54 0 0 1-3.819 1.506 5.54 5.54 0 0 1-3.818-1.506A5.023 5.023 0 0 1 17.3 17.43c0-1.364.57-2.672 1.582-3.637a5.54 5.54 0 0 1 3.818-1.506Zm0 1.714c-.954 0-1.87.361-2.546 1.004a3.35 3.35 0 0 0-1.054 2.425c0 .909.38 1.78 1.054 2.424a3.695 3.695 0 0 0 2.546 1.004c.955 0 1.87-.361 2.545-1.005A3.347 3.347 0 0 0 26.3 17.43c0-.91-.38-1.782-1.055-2.425A3.693 3.693 0 0 0 22.7 14Z"
            />
        </svg>
    );
};
